import PropTypes from "prop-types";
import Loader from "shared/components/Loader";
import { useQuery } from "shared/hooks/useApi";
import useSubscription from "shared/services/subscriptions";
import { names } from "shared/services/subscriptions/constants";
import graphql from "utils/api/graphql";
import { INITIAL_VALUES } from "../utils/constants";

const Qualifications = ({ View, filter, ...props }) => {
  const variables = {
    ...filter,
    skip: parseInt(filter.skip) || INITIAL_VALUES.skip,
    take: parseInt(filter.take) || INITIAL_VALUES.take,
  };
  const query = useQuery(graphql.queries.QUALIFICATIONS, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  useSubscription({ query: names.QUALIFICATIONS, variables });
  const WrappedView = Loader(View);
  return (
    <WrappedView
      {...{
        ...props,
        ...query,
        type: "qualifications",
      }}
    />
  );
};

Qualifications.propTypes = {
  View: PropTypes.func.isRequired,
  filter: PropTypes.object,
};

Qualifications.defaultProps = {
  filter: {},
};

export default Qualifications;
